export default {
      id: "fund-add-tipbox-icon-usage",
      viewBox: "0 0 79.63 55.4",
      url: __webpack_public_path__ + "svg-sprite-defs.svg#fund-add-tipbox-icon",
      toString: function () {
        return this.url;
      }
    }